import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DetailFormDataModel } from 'src/app/config/model/detail-form-data.model';

@Component({
    selector: 'text-view-area',
    templateUrl: './text-view-area.component.html',
    styleUrls: ['./text-view-area.component.css'],
    standalone: false
})
export class TextViewAreaComponent implements OnInit {
  constructor() {}

  @Input() prop: any = {};
  @Input() graphicFormGroup: UntypedFormGroup;
  @Input() detailFormDataModel: DetailFormDataModel;

  ngOnInit() {}
}
